import { render, staticRenderFns } from "./ChatSettings.vue?vue&type=template&id=cd5ef75c&scoped=true"
import script from "./ChatSettings.vue?vue&type=script&lang=js"
export * from "./ChatSettings.vue?vue&type=script&lang=js"
import style0 from "./ChatSettings.vue?vue&type=style&index=0&id=cd5ef75c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5ef75c",
  null
  
)

export default component.exports